import { MouseEvent, useCallback, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import View from '@picsart/view/View';

import { BATCH_TOOLS } from 'pages/Batch/configs';
import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import GridItemComponent from 'pages/Batch/components/GridItemComponent';

import useStyles from '../styles';

interface IGridItemBox {
  isSelectedItem: boolean;
  isUploadDone: boolean;
  imgSrc: string;
  children: any;
  itemKey: string;
  onClick: (ev: MouseEvent<HTMLElement>) => void;
}

const GridItemBox = ({
  isSelectedItem,
  isUploadDone,
  imgSrc,
  children,
  itemKey,
  onClick,
}: IGridItemBox) => {
  const { activeTool } = useBatchData();
  const isEnhance = activeTool === BATCH_TOOLS.enhance;
  const classes = useStyles({ pointer: isEnhance });
  const mouseDownPosition = useRef({ x: 0, y: 0 });

  const [{ width, height }, setBoxSizes] = useState({
    width: 0,
    height: 0,
  });

  const CurrentGridItem = useMemo(() => GridItemComponent[activeTool || 'defaultItem'].component, [activeTool]);

  const handleRef = useCallback((ref: HTMLDivElement | null) => {
    ref && setBoxSizes({
      width: ref.offsetWidth,
      height: ref.offsetHeight,
    });
  }, []);

  const handleMouseDown = (event: MouseEvent<HTMLElement>) => {
    mouseDownPosition.current = { x: event.clientX, y: event.clientY };
  };

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    // Prevent the item click event while moving the crop rectangle.
    const isClickPositionMoved = event.clientX !== mouseDownPosition.current.x || event.clientY !== mouseDownPosition.current.y;
    if (activeTool !== BATCH_TOOLS.crop || !isClickPositionMoved) {
      onClick(event);
    }
  };

  return (
    <View
      ref={handleRef}
      className={classNames(classes.gridItemContainer, classes.hoverGridItem, {
        [classes.selectedGridItem]: isSelectedItem,
      })}
      onClick={handleClick}
      onMouseDownCapture={handleMouseDown}
      data-test="photo-item"
    >
      {isUploadDone && <CurrentGridItem imgSrc={imgSrc} boxWidth={width} boxHeight={height} itemKey={itemKey} />}
      {children}
    </View>
  );
};

export default GridItemBox;
